var _getLowCodeCoreUtil;
import Icon from "./logo";
import { getGroupSetterSnippet, getMixedSetterSnippet } from "../../common/manager/setter-snippet";
import ColumnSelectSetter from "../../common/setter/column-select-setter";
import BLOCK_RESIZE_MAP from "../cn-layout-cell/components/split/block-resize-map";
import { updateSpan } from "../cn-layout-cell/components/split/auto-block";
import { getLowCodeCoreUtil } from "../../common/util/util";
import IdSetter from "../../common/setter/id-setter";
var getAcc = function getAcc(arr, index) {
  if (Array.isArray(arr) && arr.length > 0) {
    return arr.reduce(function (last, count, i) {
      if (i <= index) {
        return +count + last;
      }
      return last;
    }, 0);
  }
  return 0;
};
var CnLayoutBlockPrototype = {
  title: '块',
  componentName: 'CnLayoutBlock',
  // category: '图表',
  icon: Icon,
  docUrl: '',
  isContainer: true,
  canResizing: function canResizing(node, triggerDirection, c) {
    updateSpan({
      parent: node.parent,
      child: node,
      type: 'refresh'
    });
    if (['w', 'e'].includes(triggerDirection)) {
      return true;
    }
  },
  // canUseCondition:true,
  onResizeStart: function onResizeStart(e, d, currentNode) {
    var parent = currentNode.parent;
    if (parent) {
      var parentNode = parent.getDOMNode();
      if (parentNode) {
        currentNode.parentRect = parentNode.getBoundingClientRect();
      }
    }
    currentNode.lastDeltaX = 0;
    currentNode.lastGroupList = '';
  },
  onResize: function onResize(e, d, currentNode) {
    // 获取合法移动位移
    // 判断是否要变化
    // 更新鼠标开始位置，更新span信息
    var deltaX = e.deltaX,
      trigger = e.trigger;
    // trigger 可能为 e（右） 或 w（左）
    var parentIndex = currentNode.index;
    var lastFlatenMap = currentNode.parent.lastFlatenMap;
    if (!lastFlatenMap) {
      return;
    }
    var _lastFlatenMap$parent = lastFlatenMap[parentIndex],
      groupInnerIndex = _lastFlatenMap$parent.groupInnerIndex,
      groupList = _lastFlatenMap$parent.groupList;
    var latestDeltaX = deltaX - currentNode.lastDeltaX || 0;

    // 当前 groupList 是 4 4 4
    // 根据左右方向确认是 r 还是 l
    // 根据resize handleer 方向（w e） 和 当前的 groupInnerIndex ，确定分割线位置
    // 假如算出来的是 1r
    //  4 4 4 + 1r = 6 3 3
    // 在「groupInnerIndex === 0， deltaX 往右移动两格」或 「groupInnerIndex === 1」deltaX往左移动两格时
    //  再updateColSpan

    var direction = latestDeltaX > 0 ? 'r' : 'l';
    var operation = "" + (trigger === 'e' ? groupInnerIndex + 1 : groupInnerIndex) + direction;
    var afterGroupList = BLOCK_RESIZE_MAP[groupList] && BLOCK_RESIZE_MAP[groupList][operation];
    var groupAccInnerIndex = trigger === 'e' ? groupInnerIndex : groupInnerIndex - 1;
    if (!afterGroupList) {
      return;
    }
    var step = getAcc(afterGroupList.split(','), groupAccInnerIndex) - getAcc(groupList.split(','), groupAccInnerIndex);
    if (currentNode.movementAtOnce === step && currentNode.lastGroupList === groupList) {
      return;
    }
    var stepPx = currentNode.parentRect.width / 12 * step;
    var tolerance = 40;

    // console.log('stepPx:', stepPx, '  tolerance:', tolerance)

    if (Math.abs(latestDeltaX) > Math.abs(stepPx) - tolerance) {
      currentNode.movementAtOnce = step;
      currentNode.lastGroupList = groupList;
      currentNode.lastDeltaX += stepPx;
      updateSpan({
        parent: currentNode.parent,
        child: currentNode,
        type: 'resize',
        direction: trigger,
        // 默认是 e , 也就是拖拽区块右边的线进行resize
        offset: step
      });
    }
  },
  onResizeEnd: function onResizeEnd(e, d, currentNode) {
    currentNode.movementAtOnce = 'clear';
  },
  configure: [{
    name: 'isCnLayoutBlock',
    title: 'CnLayoutBlock',
    initialValue: true,
    display: 'none'
  }, {
    name: '_context',
    title: '上下文',
    initialValue: {
      type: 'JSExpression',
      value: 'this'
    },
    display: 'none'
  }, {
    title: '样式',
    type: 'group',
    display: 'accordion',
    collapsed: false,
    items: [{
      name: 'hidden',
      display: 'inline',
      title: '是否隐藏',
      setter: 'VariableSetter',
      supportVariable: true
    }]
  }, getGroupSetterSnippet({
    items: [{
      name: 'span',
      title: '在一行中占几列(共12列)',
      display: 'inline',
      setter: getMixedSetterSnippet({
        setters: [{
          componentName: ColumnSelectSetter,
          title: '图形选择'
        }, {
          componentName: 'NumberSetter',
          title: '数字输入'
        }]
      })
    }],
    outerConfig: {
      title: '布局'
    }
  }), {
    name: 'buttons',
    title: '底部按钮栏',
    display: 'accordion',
    // collapsed:false,
    initialValue: [],
    setter: (_getLowCodeCoreUtil = getLowCodeCoreUtil('button.createButtonListSetters')) === null || _getLowCodeCoreUtil === void 0 ? void 0 : _getLowCodeCoreUtil({
      position: getLowCodeCoreUtil('enumMap.ButtonPosition.blockButton')
    })
  }, {
    title: '高级配置',
    type: 'group',
    collapsed: true,
    display: 'accordion',
    items: [{
      name: '_nodeId',
      title: '节点 ID',
      display: 'inline',
      initialValue: function initialValue() {
        return this.getNode().id;
      },
      setter: /*#__PURE__*/React.createElement(IdSetter, null)
    }, {
      name: 'handleProps',
      title: '手动设置组件props',
      display: 'inline',
      setter: {
        title: '写js表达式',
        componentName: 'CnRowDataSetter',
        props: function props() {
          return {
            list: [],
            initialCode: "(oldProps, state) => {\n  // \u7ED9\u7EC4\u4EF6\u8BBE\u7F6E\u65B0\u7684props\u3002\n  // oldProps.xxx = 'xxx'\n  // return oldProps;\n}",
            tip: "\noldProps: \u7EC4\u4EF6\u7684\u539F\u59CBprops\nstate\uFF1A\u5168\u90E8\u7684\u6570\u636E\uFF0C\u5728\u5DE6\u4FA7\u5217\u8868\u4E2D\u9009\u62E9\u4F7F\u7528\u3002\n"
          };
        }
      }
    }]
  }]
};

// 原型配置请参考：https://lark.alipay.com/vision/docs/prototype

export { CnLayoutBlockPrototype };